export enum ValidationMessages {
  RequireField = "Feltet er påkrevd",
  InvalidEmail = "Ugyldig e-postadresse",
  InvalidOrgnummer = "Organisasjonsnummer må være 9 siffer",
  InvalidFnr = "Fødselsnummeret er ikke gyldig",
  RequiredFnr = "Fødselsnummeret er påkrevd",
  LengthAndNumberFnr = "Fødselsnummeret må være 11 siffer",
  InvalidMobilnummer = "Mobilnummeret må være 8 siffer",
}
